import React, {InputHTMLAttributes} from 'react';
// import {isMobile} from 'react-device-detect';
import {ErrorType} from '../../../utils/common';
import {useScreenResize} from '../../../utils/hooks';
import {device} from '../../../styled/device';
import Tooltip from '../Tooltip';
import styles from './Input.module.sass';
import {FieldQuestionMarkButton, LabelInput, RelativeWrapper, StyledInput, TooltipTrigger, WrapperInput, ErrorMessage} from './styled';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  invalid?: boolean;
  error?: ErrorType;
  inputMode?:
    | 'text'
    | 'none'
    | 'tel'
    | 'url'
    | 'email'
    | 'numeric'
    | 'decimal'
    | 'search';
  tooltipContentKey?: string;
};

const defaultProps: InputProps = {
  onChange: undefined,
  label: '',
  invalid: undefined,
  error: '',
  inputMode: undefined,
  autoComplete: 'on',
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      value,
      onChange,
      className,
      label,
      invalid,
      defaultValue,
      disabled,
      name,
      type,
      max,
      error,
      autoComplete,
      inputMode,
      children,
      tooltipContentKey,
      ...props
    },
    ref,
  ) => {
    const {isMatch} = useScreenResize(device.tablet);
    const isMobileMode = isMatch /*|| isMobile*/;
    const position = isMobileMode ? 'top center' : 'top right';

    return (
      <WrapperInput disabled={disabled}>
        <LabelInput htmlFor={name}>
          {label}
          {tooltipContentKey && (
            <Tooltip position={position} label={tooltipContentKey}>
              <TooltipTrigger>
                <FieldQuestionMarkButton />
              </TooltipTrigger>
            </Tooltip>
          )}
        </LabelInput>
        <RelativeWrapper>
          {children || (
            <StyledInput className={'input___input'}
              ref={ref}
              type={type}
              data-testid="input"
              value={value}
              onChange={onChange}
              disabled={disabled}
              defaultValue={defaultValue}
              aria-label={name}
              name={name}
              max={max}
              autoComplete={autoComplete}
              inputMode={inputMode}
              {...props}
            />
          )}
        </RelativeWrapper>

        {error && (
          <ErrorMessage>
            {/* {error} */} error
          </ErrorMessage>
        )}
      </WrapperInput>
    );
  },
);

Input.defaultProps = defaultProps;
export {Input};
